// extracted by mini-css-extract-plugin
module.exports = {"separator":"_1da8p","title":"_1Hy2G","text":"_1-Tvw","button":"vrh6Z","rightButton":"_124X- vrh6Z","buttons":"zLx2f","iconRoot":"_2QanL","icon":"_1zb6a","resiliationIcon":"_2DXfJ"};